import React, {useState, Fragment} from 'react'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'

// Material-UI Icon
import IconButton from '@material-ui/core/IconButton'
import LaunchIcon from '@material-ui/icons/Launch'

// Material-UI Lab
import Pagination from '@material-ui/lab/Pagination'

// Custom Components
import DocSubSearchResultTableHead from './DocSubSearchResultTableHead'

// Custom Style
import docSubSearchResultTableStyle from '../../styles/jss/components/documentSubmission/docSubSearchResultTableStyle'


const useStyles = makeStyles(theme => docSubSearchResultTableStyle(theme))

const DocSubSearchResultTable = props => {
	const {searchResult, docSubDetailDialogHandleOpen} = props
	const classes = useStyles()
	
	const [order, setOrder] = useState('desc')   // asc, desc
	const [orderBy, setOrderBy] = useState('modified')
	const [page, setPage] = useState(1)
	const [rowsPerPage, setRowsPerPage] = useState(20)

	const createData = (submissionSeq, submissionNo, typeName, confidential, refNo, submitDate, modifyDate, stageName) => {
		return {submissionSeq, submissionNo, typeName, confidential, refNo, submitDate, modifyDate, stageName}
	}
	
	const generateTableData = (searchResult) => {
		let rows = []
	
		searchResult.map(res => {
			rows = [...rows, createData(res.subm_seq, res.subm_code, res.type_name, res.is_confidential, res.ref_cover_no, res.createdate, res.modifydate, res.stage_name)]
		})
	
		return rows
	}
	
	const descendingComparator = (a, b, orderBy) => {
		if (b[orderBy] < a[orderBy]) {
			return -1
		}
	
		if (b[orderBy] > a[orderBy]) {
			return 1
		}
	
		return 0
	}
	
	const getComparator = (order, orderBy) => {
		return order === 'desc' 
		? (a, b) => descendingComparator(a, b, orderBy) 
		: (a, b) => -descendingComparator(a, b, orderBy)
	}
	
	const stableSort = (array, comparator) => {
		const stabilizedThis = array.map((el, index) => [el, index])
	
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0])
			
			if (order !== 0) return order
				return a[1] - b[1]
		})
	
		return stabilizedThis.map((el) => el[0])
	}

	const searchResultHeader = [
		{id: 'readIcon', numeric: false, disablePadding: true, label: ''},
		{id: 'submissionNo', numeric: false, disablePadding: false, label: 'Submission No.'},
		{id: 'typeName', numeric: false, disablePadding: false, label: 'Submission Type'},
		{id: 'confidential', numeric: false, disablePadding: false, label: 'Confidential'},
		{id: 'refNo', numeric: false, disablePadding: false, label: 'Ref No. / Cover No.'},
		{id: 'submitDate', numeric: false, disablePadding: false, label: 'Submission Date'},
		{id: 'modifyDate', numeric: false, disablePadding: false, label: 'Last Updated Date'},
		{id: 'stageName', numeric: false, disablePadding: false, label: 'Stage'}
	]

	const rows = generateTableData(searchResult)

	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === 'asc'
		setOrder(isAsc ? 'desc' : 'asc')
		setOrderBy(property)
	}

	const handleChangePage = (event, newPage) => {
		setPage(newPage)
	}


	return (
		<div className={classes.root}>
			<TableContainer id="scrollableDiv" className={classes.container}>
				<Table
					stickyHeader
					className={classes.table}
					aria-labelledby="tableTitle"
					size='small'
					aria-label="eFiling list"
				>

					<DocSubSearchResultTableHead
						headCells={searchResultHeader}
						order={order}
						orderBy={orderBy}
						onRequestSort={handleRequestSort}
					/>

					<TableBody>
						{/* {stableSort(rows, getComparator(order, orderBy)).map((row, index) => { */}

						{stableSort(rows, getComparator(order, orderBy))
							.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)
							.map((row, index) => {

							return (
								<Fragment key={index}>
									<TableRow style = {index % 2 ? {background: "rgba(255, 255, 230, 0.5)"} : {background : "white"}}>
										<TableCell align="left">
											<IconButton color="primary" onClick={() => docSubDetailDialogHandleOpen(row.submissionSeq)}>
          										<LaunchIcon />
        									</IconButton>	
										</TableCell>

										{/* <TableCell align="left"><div data-submissionseq={row.submissionSeq} onClick={docSubDetailDialogHandleOpen} className={classes.linkContent}>{row.submissionNo}</div></TableCell> */}
										<TableCell align="left">{row.submissionNo}</TableCell>
										<TableCell align="left">{row.typeName}</TableCell>
										<TableCell align="left">{row.confidential ? "Y" : "N"}</TableCell>
										<TableCell align="left">{row.refNo !== null ? row.refNo : "---"}</TableCell>
										<TableCell align="left">{row.submitDate}</TableCell>
										<TableCell align="left">{row.modifyDate}</TableCell>
										<TableCell align="left">{row.stageName}</TableCell>
									</TableRow>
								</Fragment>
							)
						})}
					</TableBody>
				</Table>
			</TableContainer>

			{/* <Pagination count={Math.ceil(rows.length / rowsPerPage)} variant="outlined" shape="rounded" onChange={handleChangePage} page={page} className={classes.tablePagination}/> */}
			<Pagination 
				count={Math.ceil(rows.length / rowsPerPage)} 
				variant="outlined" 
				shape="rounded"
				onChange={handleChangePage}
				page={page}
				className={classes.tablePagination}
			/>
		</div>
	)
}


export default DocSubSearchResultTable